import React from 'react';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';

const PaidAction = ({ children }) => {
  const user = useSelector(state => state.user);

  const handleClick = (e) => {
    if (user?.plan_free) {
      toast.error('Esta acción solo está disponible para usuarios con plan de pago');
      return;
    }

    if (children.props?.onClick) children.props.onClick(e);
    if (children.props?.onPress) children.props.onPress(e);
  }

  return React.cloneElement(children, {
    onClick: children.props.onClick ? handleClick : () => {},
    onPress: children.props.onPress ? handleClick : () => {}
  });
}

export default PaidAction